const destinations = [
  { name: "Nigeria & Angola", context: "Deepwater offshore platform rotations from Lafourche Parish for subsea engineers, drillers, and marine coordinators", urgency: "International rotation papers typically arrive with 10–21 days notice — passports must be current", icon: "ri-map-pin-2-line" },
  { name: "France & French Caribbean", context: "Heritage travel for Thibodaux's Cajun-French community; Martinique and Guadeloupe visits for families with historical ties", urgency: "Heritage travel is often planned during family milestones and seasonal gatherings", icon: "ri-map-pin-2-line" },
  { name: "Australia & Brazil", context: "Sugarcane industry conferences, agricultural equipment sourcing, and agronomy research trips from Lafourche Parish growers", urgency: "Agricultural industry events are calendar-fixed and rarely adjusted for passport issues", icon: "ri-map-pin-2-line" },
  { name: "Norway & United Kingdom", context: "North Sea platform rotations and offshore energy contractor assignments from Thibodaux-based workers", urgency: "North Sea rotation timelines are as compressed as Gulf of Mexico international assignments", icon: "ri-map-pin-2-line" },
  { name: "Mexico & Caribbean", context: "Family cruise departures from New Orleans and Galveston; all-inclusive resort vacations for Lafourche Parish families", urgency: "Cruise deal bookings happen fast — passport checks often follow ticket purchase rather than precede it", icon: "ri-map-pin-2-line" },
  { name: "Spain & Italy", context: "NSU faculty research travel, academic conference attendance, and European cultural exchange programs for Nicholls State students", urgency: "Study-abroad application deadlines fall in Oct and Feb — passports discovered late create real urgencies", icon: "ri-map-pin-2-line" },
];

const stats = [
  { stat: "60 Miles", label: "from Thibodaux to the New Orleans Passport Agency — our service eliminates that drive entirely" },
  { stat: "10–21 Days", label: "typical notice for offshore international rotation assignments from Lafourche Parish workers" },
  { stat: "Feb & Oct", label: "peak study-abroad application deadlines at NSU — when student passport urgencies spike" },
  { stat: "Year-Round", label: "offshore rotation cycles create consistent passport demand regardless of leisure travel seasons" },
];

export default function ThibodauxDestinationsSection() {
  return (
    <section className="bg-white py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Local Travel Intelligence</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Where Thibodaux Travelers Go — And Why Passports Get Urgent
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed">
            These are the destinations and travel patterns we see most from Thibodaux and Lafourche Parish clients — from offshore rotations to student study abroad to Cajun heritage travel.
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mb-14">
          {stats.map((s, i) => (
            <div key={i} className="bg-[#1A365D] rounded-lg p-6 text-center">
              <p className="font-serif text-3xl font-bold text-[#F6C344] mb-2">{s.stat}</p>
              <p className="text-white/60 text-xs leading-relaxed">{s.label}</p>
            </div>
          ))}
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 mb-12">
          {destinations.map((d, i) => (
            <div key={i} className="bg-[#F7F8FA] rounded-lg p-6 border border-gray-200 hover:border-[#F6C344] transition-all group">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 flex items-center justify-center rounded-full bg-[#1A365D]/5 group-hover:bg-[#F6C344]/15 transition-colors flex-shrink-0">
                  <i className={`${d.icon} text-[#1A365D] group-hover:text-[#F6C344] transition-colors text-lg`}></i>
                </div>
                <h3 className="font-bold text-[#1A365D] text-sm">{d.name}</h3>
              </div>
              <p className="text-gray-500 text-sm leading-relaxed mb-3">{d.context}</p>
              <div className="flex items-start gap-2">
                <i className="ri-time-line text-[#F6C344] text-xs flex-shrink-0 mt-0.5"></i>
                <p className="text-gray-400 text-xs leading-relaxed italic">{d.urgency}</p>
              </div>
            </div>
          ))}
        </div>
        <div className="bg-[#F7F8FA] rounded-lg p-6 border border-gray-200">
          <div className="flex flex-col md:flex-row items-start md:items-center gap-4">
            <div className="w-12 h-12 flex items-center justify-center rounded-full bg-[#1A365D]/5 flex-shrink-0">
              <i className="ri-links-line text-[#1A365D] text-xl"></i>
            </div>
            <div className="flex-1">
              <h3 className="font-bold text-[#1A365D] text-sm mb-1">Explore Other Louisiana Service Areas</h3>
              <p className="text-gray-500 text-sm leading-relaxed">
                We serve travelers across Louisiana with the same professional expedited passport processing. Looking for service in another community?
              </p>
            </div>
            <div className="flex flex-wrap gap-2 flex-shrink-0">
              {[
                { name: "Houma", href: "/cities/houma" },
                { name: "New Orleans", href: "/cities/new-orleans" },
                { name: "Baton Rouge", href: "/cities/baton-rouge" },
              ].map((link) => (
                <a key={link.href} href={link.href} className="inline-flex items-center gap-1.5 bg-white hover:bg-[#1A365D] text-[#1A365D] hover:text-white border border-gray-200 hover:border-[#1A365D] font-medium text-xs px-3.5 py-2 rounded-md transition-all whitespace-nowrap">
                  {link.name} <i className="ri-arrow-right-line text-xs"></i>
                </a>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}